import React from "react";

import { useTranslation } from "react-i18next";
import { Button } from "../../../components/ui/button/Button";
import {
  HeaderButtons,
  HeaderContainer,
  HeaderDetails,
  HeaderHeading,
} from "./styles";

const Header = ({ onClick = () => {}, hasSave = true }) => {
  const { t } = useTranslation();

  return (
    <HeaderContainer>
      <HeaderDetails>
        <img
          src="/img/MacroSuiteIcon.svg"
          alt="Optics"
          width={42}
          height={42}
        />
        <HeaderHeading>Optics</HeaderHeading>
      </HeaderDetails>
      <HeaderButtons>
        <Button appearance="secondary" onClick={() => window.AP.dialog.close()}>
          {t("close")}
        </Button>
        {hasSave && (
          <Button appearance="primary" onClick={onClick}>
            {t("add-to-page")}
          </Button>
        )}
      </HeaderButtons>
    </HeaderContainer>
  );
};

export default Header;
